// extracted by mini-css-extract-plugin
export default {"CaseSearchContainer":"AeVRgvN3","ResultPanelGroup":"YNVLVsOP","ResultPanel":"NCa90oqm"};